var render = function render(){var _vm=this,_c=_vm._self._c;return _c('box-model',{attrs:{"title":"种植规模情况"},scopedSlots:_vm._u([{key:"content",fn:function(){return [(!_vm.show)?_c('div',{staticClass:"con no-data-sty"},[_vm._v("暂无数据")]):_c('div',{staticClass:"con",attrs:{"id":"line"}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }